import React from 'react';
import { Box } from '@mui/material';
export default function Index({
  color,
  size,
  width = '14px',
  height = '18px',
  ...other
}) {
  return (
    <Box
      component="svg"
      width={width}
      height={height}
      viewBox="0 0 12 16"
      fill="none"
      color={color ? color : 'primaryText'}
      {...other}
    >
      <path
        d="M2.40001 6.03719V5.24079C2.40001 3.22383 4.00573 1.59985 6.00001 1.59985C7.06409 1.59985 8.01755 2.06218 8.67549 2.79985M6.00001 10.4569V8.85688M10.8 9.62124C10.8 12.2605 8.65098 14.4 6.00001 14.4C3.34905 14.4 1.20001 12.2605 1.20001 9.62124C1.20001 6.98202 3.34905 4.84251 6.00001 4.84251C8.65098 4.84251 10.8 6.98202 10.8 9.62124Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </Box>
  );
}
